/* eslint-disable n/no-callback-literal */
import { connect } from 'itty-sockets'
import React, { Suspense, type ReactElement, useContext } from 'react'
import QRCode from 'react-qr-code'
import { RoomSettingsContext } from '../pages/+RoomSettingsContext'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWEXYZ'

const badWords = [
  'anus',
  'arse',
  'butt',
  'clit',
  'cock',
  'coon',
  'cunt',
  'dago',
  'damn',
  'dick',
  'dike',
  'dyke',
  'fuck',
  'gook',
  'heeb',
  'hell',
  'homo',
  'jizz',
  'kike',
  'kunt',
  'kyke',
  'mick',
  'muff',
  'nazi',
  'paki',
  'piss',
  'poon',
  'puto',
  'shit',
  'shiz',
  'slut',
  'smeg',
  'spic',
  'tard',
  'tits',
  'twat',
  'twit',
  'wank'
]

let tempChannel: any
let tempLobbyChannel: any

const createRoom = (
  name: string,
  callback: any,
  actions: any,
  attempts: number,
  lobby: boolean = false,
  version: string = '',
  prevRoomCode?: string | undefined
): void => {
  let newRoomCode: string

  const handleJoinLobby = ({
    uid,
    alias,
    total,
    self
  }: {
    uid: string
    alias: string
    total: number
    self: boolean
  }) => {
    if (!self) return
    if (total > 1 && prevRoomCode === undefined) {
      if (tempChannel) tempChannel.close()
      tempLobbyChannel.close()

      createRoom(
        name,
        callback,
        actions,
        attempts + 1,
        lobby,
        version,
        prevRoomCode
      )
    } else {
      tempLobbyChannel.myId = uid
      tempLobbyChannel.myAlias = alias

      tempChannel = connect('reactvts-' + newRoomCode + '-game', {
        as: 'server-' + name,
        announce: true,
        list: true
      })

      tempChannel.on('join', handleJoinPrivateRoom)
    }
  }

  const handleJoinPrivateRoom = ({
    uid,
    alias,
    total,
    self
  }: {
    uid: string
    alias: string
    total: number
    self: boolean
  }) => {
    if (!self) return
    if (total > 1) {
      tempChannel.close()
      tempLobbyChannel.close()

      createRoom(name, callback, actions, attempts + 1, lobby)
    } else {
      tempLobbyChannel.on('join', (message: any) => {
        actions.triggerLobbyEnter(message, tempLobbyChannel)
      })
      tempLobbyChannel.on('message', (message: any) => {
        actions.triggerAction(message, tempLobbyChannel)
      })
      tempChannel.on('join', (message: any) => {
        actions.triggerEnter(message, tempChannel)
      })
      tempChannel.on('message', (message: any) => {
        actions.triggerAction(message, tempChannel)
      })

      tempChannel.remove(handleJoinPrivateRoom)
      tempLobbyChannel.remove(handleJoinLobby)

      tempChannel.myId = uid
      tempChannel.myAlias = alias

      callback({
        roomCode: newRoomCode,
        channel: tempChannel,
        lobbyChannel: tempLobbyChannel
      })
    }
  }

  const handleJoinRoom = function ({
    uid,
    alias,
    total,
    self
  }: {
    uid: string
    alias: string
    total: number
    self: boolean
  }) {
    if (!self) return
    if (total > 1) {
      tempChannel.close()
      createRoom(name, callback, actions, attempts + 1, lobby, version)
    } else {
      tempChannel.on('join', (message: any) => {
        actions.triggerEnter(message, tempChannel)
      })
      tempChannel.on('message', (message: any) => {
        actions.triggerAction(message, tempChannel)
      })
      tempChannel.remove(handleJoinRoom)
      tempChannel.myId = uid
      tempChannel.myAlias = alias
      callback({ roomCode: newRoomCode, channel: tempChannel })
    }
  }

  if (attempts >= 2) {
    callback(false)
  } else {
    if (prevRoomCode === undefined) {
      do {
        newRoomCode =
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          alphabet[Math.floor(Math.random() * alphabet.length)] +
          version
        console.log(newRoomCode)
      } while (badWords.includes(newRoomCode.toLowerCase()))
    } else {
      newRoomCode = prevRoomCode
    }

    if (lobby) {
      tempLobbyChannel = connect('reactvts-' + newRoomCode, {
        as: 'lobby-' + name,
        announce: true,
        list: true
      })

      tempLobbyChannel.on('join', handleJoinLobby)
    } else {
      tempChannel = connect('reactvts-' + newRoomCode, {
        as: 'server-' + name,
        announce: true,
        list: true
      })

      tempChannel.on('join', handleJoinRoom)
    }
  }
}

const connection = (
  name: string,
  callback: any,
  actions: any,
  lobby: boolean = false,
  version: string = '',
  prevRoomCode?: string | undefined
): void => {
  createRoom(name, callback, actions, 0, lobby, version, prevRoomCode)
}
const RoomCode = ({
  roomCode,
  hide = false,
  left = false
}: {
  roomCode: string | undefined
  hide?: boolean
  left?: boolean
}): ReactElement => {
  const { roomSettings } = useContext(RoomSettingsContext)
  const styles = {
    box: {
      position: 'fixed',
      bottom: '15px',
      right: left ? 'auto' : '15px',
      left: left ? '15px' : 'auto',
      fontSize: '75px',
      color: 'black',
      zIndex: 10,
      border: '10px solid',
      borderColor: 'yellow.300',
      backgroundColor: 'yellow.300',
      'path:nth-of-type(1)': {
        display: 'none'
      }
    },
    qrCodeBoth: {
      bottom: '1.25em'
    }
  }
  if (
    roomSettings !== null &&
    roomSettings.options.hideRoomCode.value === false &&
    !hide
  ) {
    switch (roomSettings.options.roomCodeType.value) {
      case 'text':
        return (
          <Flex
            aspectRatio="1"
            flexDir={'column'}
            justifyContent={'center'}
            sx={{ ...styles.box }}
            boxShadow="sm"
          >
            <Text
              fontSize={{ base: '12px', xl: '16px', '2xl': '26px' }}
              lineHeight="0.9"
              fontWeight="800"
              letterSpacing="-0.025em"
              textAlign="center"
              pb="0.0em"
              mb="0"
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              Reactvts.com/join <br />
              <br />
              Room Code:
            </Text>
            <Heading
              as="p"
              textAlign="center"
              sx={{
                fontSize: { base: '43px', xl: '60px', '2xl': '85px' },
                lineHeight: 0.8,
                letterSpacing: '-0.1em',
                color: 'gray.700',
                zIndex: 1000,
                mb: 0
              }}
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              {roomCode ?? ''}
            </Heading>
          </Flex>
        )
      case 'bizhawk':
        return (
          <Flex
            aspectRatio="1"
            flexDir={'column'}
            justifyContent={'center'}
            sx={{ ...styles.box }}
            boxShadow="sm"
          >
            <Text
              fontSize={{ base: '16px', '2xl': '26px' }}
              lineHeight="1.2"
              fontWeight="800"
              letterSpacing="-0.025em"
              textAlign="center"
              pb="0em"
              mb="0"
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              Setup Instruction at <br />
              Reactvts.com/join <br />
              <br />
              Room code:
            </Text>
            <Heading
              as="p"
              textAlign="center"
              sx={{
                fontSize: { base: '32px', '2xl': '85px' },
                lineHeight: 0.8,
                letterSpacing: '-0.1em',
                color: 'gray.700',
                zIndex: 1000,
                mb: 0
              }}
              px={{ base: '5px', lg: '10px', '2xl': '20px' }}
            >
              {roomCode ?? ''}
            </Heading>
          </Flex>
        )
      case 'qrCode':
      default:
        return (
          <Box sx={styles.box} boxShadow="md">
            <Heading
              textAlign="center"
              fontWeight="800"
              lineHeight="1.1"
              mb="1.5"
              fontSize="26px"
            >
              Scan&nbsp;to Join
            </Heading>
            {typeof roomCode !== 'undefined' && (
              <Suspense fallback={<div>Loading QR Code...</div>}>
                <QRCode
                  fgColor="#2d3748"
                  bgColor="transparent"
                  size={200}
                  value={`http://reactvts.com/join?room-code=${roomCode ?? ''}`}
                />
              </Suspense>
            )}
            <Heading
              textAlign="center"
              fontWeight="800"
              lineHeight="1.1"
              mt="1.5"
              mb="0"
              fontSize={{ base: '5px', xl: '20px' }}
            >
              Room Code: {roomCode ?? ''}
            </Heading>
          </Box>
        )
    }
  } else {
    return <Box></Box>
  }
}

export { connection, RoomCode }
